var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"text-center text-warning"},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Warning: You are not authorised to view that page. ")])
}]

export { render, staticRenderFns }